import { EntityService } from './EntityService';
import { ContextService } from './ContextService';
import { IUserProject } from '../types';
import { AppGlobals } from '../AppGlobals';

export class UserProjectService extends EntityService<IUserProject> {
    constructor() {
        super(`/UserProjects`);
    }

    public readAllForList(projectID?: number): Promise<IUserProject[]> {
        return this.readAll(
            `?$orderby=User/Title&$expand=User,Project&$filter=User/CustomerID eq ${AppGlobals.CustomerID}`
            + (projectID ? ` and ProjectID eq ${projectID}` : '')
        );
    }

    public readMyProjects(): Promise<IUserProject[]> {
        return this.readAll(`?$filter=User/Username eq '${encodeURIComponent(ContextService.Username())}'`);
    }

    public readProjectAdmins(projectId: number): Promise<IUserProject[]> {
        return this.readAll(`?$filter=ProjectID eq ${projectId} and IsAdmin eq true&$expand=User`);
    }

    public readAllForLookup(): Promise<IUserProject[]> {
        return this.readAll(`?$select=ID,Title,ProjectID,UserID&$orderby=Title`);
    }

    public checkForDuplicates = (userId: number, projectId: number): Promise<IUserProject[]> => {
        return this.readAll(`?$filter=UserID eq ${userId} and ProjectID eq ${projectId}&$select=ID`);
    }
}